import { render, staticRenderFns } from "./StatisticsGuests.vue?vue&type=template&id=b90b8388&scoped=true&"
import script from "./StatisticsGuests.vue?vue&type=script&lang=js&"
export * from "./StatisticsGuests.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsGuests.vue?vue&type=style&index=0&id=b90b8388&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90b8388",
  null
  
)

export default component.exports